import { createUseStyles } from 'react-jss'
import { LIGHT_GRAY, DARK, RED, WHITE } from '@omnilert/components'


const useStyles = createUseStyles({
  button: {
    alignItems: 'center',
    backgroundColor: RED,
    border: 'medium none',
    borderRadius: '50%',
    bottom: '2px',
    display: 'flex',
    height: '24px',
    justifyContent: 'center',
    left: '70%',
    padding: '3px',
    position: 'absolute',
    right: '0',
    top: '-8px',
    visibility: ({ uploading }) => uploading ? 'hidden' : 'visible',
    width: '24px',
    zIndex: '100',
    '&:hover': {
      cursor: 'pointer'
    }
  },
  container: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    paddingRight: '18px',
    position: 'relative'
  },
  fileContainer: {
    height: '100px',
    '&:hover': {
      cursor: 'pointer'
    }
  },
  file: {
    borderRadius: '5px',
    height: '90px',
    border: ['3px', 'solid', 'var(--file-upload--border)'],
    boxShadow: '0px -1px 23px -9px rgba(0,0,0,0.74)',
    objectFit: 'cover',
    width: '90px'
  },
  icon: {
    '--icon__primary__stroke__color': WHITE,
    height: '10px !important'
  },
  progressBarContainer: {
    alignItems: 'center',
    backgroundColor: DARK,
    border: ['3px', 'solid', DARK],
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    height: '100px',
    justifyContent: 'center',
    opacity: '.8',
    marginBottom: '5px',
    position: 'absolute',
    width: '100px',
    zIndex: '100'
  },
  progressText: {
    marginTop: '5px !important'
  },
  uploading: {
    '--icon__primary__stroke__color': LIGHT_GRAY
  }
})

export default useStyles

